import * as React from "react";

function Sandglass2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M44 56c0-7.55.44-14.67-5.6-19.2l-12.8-9.6C19.56 22.67 20 15.55 20 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 8c0 7.55.44 14.67-5.6 19.2l-12.8 9.6C19.56 41.33 20 48.45 20 56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 52,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 56,
    x2: 12,
    y2: 56
  }));
}

export default Sandglass2Icon;